module.exports = __webpack_public_path__ + "img/GAME_BEAUTIFULFLOWER2.3a6f7a4e.jpg";